export const isKeyExpired = (expiresAt: string, now: number): boolean => {
  return now >= Date.parse(expiresAt);
};

const pad2 = (n: number): string => String(n).padStart(2, "0");

export const formatCountdown = (expiresAt: string, now: number): string => {
  const remainingMs = Date.parse(expiresAt) - now;
  const remainingSec = Math.max(0, Math.floor(remainingMs / 1000));

  const days = Math.floor(remainingSec / 86400);
  const hours = Math.floor((remainingSec % 86400) / 3600);
  const minutes = Math.floor((remainingSec % 3600) / 60);
  const seconds = remainingSec % 60;

  if (remainingSec === 0) return "0s";
  if (days >= 1) return `${days}d ${pad2(hours)}h`;
  if (hours >= 1) return `${hours}h ${pad2(minutes)}m`;
  if (minutes >= 1) return `${minutes}m ${pad2(seconds)}s`;
  return `${seconds}s`;
};
